// extracted by mini-css-extract-plugin
export var loader = "Loader-module--loader--Rfyly";
export var spin = "Loader-module--spin--PDUSe";
export var spinner = "Loader-module--spinner--4NC2f";